import React from 'react'
import TechnologyBanner from '../../components/TechnologyComponents/TechnologyBanner'
import TechnologySection from '../../components/TechnologyComponents/TechnologySection'

// Main component for Our App
const OurTechnology = () => {
  return (
    <>
      {/* Render the banner section for the technology page */}
      <TechnologyBanner />

      {/* Render the main technology section content */}
      <TechnologySection />
    </>
  );
}

export default OurTechnology;

